import type { SegmentTrackCheckoutStepCompletedEvent } from "@beautypie/segment/Track/CheckoutStepCompleted"
import type { SegmentTrackCheckoutStepViewedEvent } from "@beautypie/segment/Track/CheckoutStepViewed"
import type { BucketsType, LocaleType } from "lib/apollo/types"
import type { ProductPriceType } from "./helpers"

/* eslint-disable camelcase */
export interface UTMValues {
  utm_id?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  awc?: string
}

export interface PageDetails {
  title?: string
  url?: string
  referrer?: string
  path?: string
  search?: string
  name?: string
}

export type SegmentCheckoutStepData = {
  shippingCost: number
  shippingMethod: string
  hasMembership: boolean
  discount: number
  basketsByBucket: BucketsType
  locale: LocaleType
  basketTotal: number
  purchaseType: ProductPriceType
  paymentMethod?: string
}

export type SegmentTrackCheckoutEvent =
  | SegmentTrackCheckoutStepCompletedEvent
  | SegmentTrackCheckoutStepViewedEvent

export enum SegmentCheckoutEventType {
  Viewed = "Checkout Step Viewed",
  Completed = "Checkout Step Completed",
}
